import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ImageEditor from "@uppy/image-editor"
import ActiveStorageUpload from "../vendor/uppy_activestorage_upload"

export default class extends Controller {
  static targets = ["trigger", "preview", "field"]
  static values = {
    fieldName: String,
    currentUrl: { type: String, default: "" },
  }

  connect() {
    if (this.hasPreviewTarget && this.currentUrlValue) {
      this.previewTarget.src = this.currentUrlValue
    }

    this.uppy = new Uppy({
      autoProceed: false,
      allowMultipleUploads: false,
      allowMultipleUploadBatches: false,
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["image/*"],
      },
    })

    this.uppy.use(Dashboard, {
      trigger: this.triggerTarget,
      closeAfterFinish: true,
      closeModalOnClickOutside: true,
      proudlyDisplayPoweredByUppy: false,
      autoOpen: "imageEditor",
      plugins: ["ImageEditor"],
    })
    this.uppy.use(ImageEditor)
    this.uppy.use(ActiveStorageUpload, {
      directUploadUrl: this.directUploadUrl,
    })

    this.uppy.on("file-editor:complete", () => {
      this.uppy.upload()
    })
    this.uppy.on("complete", this.onComplete.bind(this))
  }

  disconnect() {
    this.uppy?.destroy()
  }

  onComplete(result) {
    result.successful.forEach((file) => {
      this.setField(file)
      this.setPreview(file)
    })
  }

  setField(file) {
    const signedId =
      file.response?.directUploadSignedId || file.response?.signed_id
    if (!signedId) return

    if (this.hasFieldTarget) {
      this.fieldTarget.name = this.fieldNameValue
      this.fieldTarget.value = signedId
    } else {
      const field = document.createElement("input")
      field.type = "hidden"
      field.dataset.uppyImageFieldTarget = "field"
      field.name = this.fieldNameValue
      field.value = signedId
      this.element.appendChild(field)
    }
  }

  setPreview(file) {
    if (!this.hasPreviewTarget) return

    const src = file.preview || URL.createObjectURL(file.data)
    this.previewTarget.src = src
    this.previewTarget.style.display = "block"
  }

  get directUploadUrl() {
    return document
      .querySelector("meta[name='direct-upload-url']")
      ?.getAttribute("content")
  }
}
